import React, { useState, useEffect, useRef } from "react";
import BalanceIcon from "@mui/icons-material/Balance";
import { ReactComponent as SendIcon } from "./assets/sendicon.svg";
import "./VideoArenaApp.css";
import ShareModal from "./ShareModal";
import confetti, { shapeFromPath } from "canvas-confetti";

function VideoArenaAppBody(props) {
  // This is the base URL for polling the API server.
  const baseURL = props.baseURL;
  let userId = useRef(props.userId);
  console.log("Language:", props.language);

  let language = props.language;

  const [token, setToken] = useState(undefined);
  const [scrollers, setScrollers] = useState([]);
  const [videoIndex, setVideoIndex] = useState(0);
  const [loadVideo, setLoadVideo] = useState(false);
  const [error, setError] = useState(false);

  const loadingIndex = useRef(-1);
  const lastVideoIndex = useRef(-1);
  const bottomVideoIndex = useRef(0);
  const topVideoIndex = useRef(0);
  const curViewIndex = useRef(-1);
  const video1EventListeners = useRef(false);
  const video2EventListeners = useRef(false);
  const videoLoading = useRef(false);
  const loadingDisplay = useRef(false);
  const pauseId = useRef(undefined);
  const playId = useRef(undefined);
  const scrollCheckId = useRef(undefined);
  const isPausePlayTimersRunning = useRef(false);

  const bodyRef = useRef(0);
  const videosRefs = useRef([]);
  const videoOneRefs = useRef([]);
  const videoTwoRefs = useRef([]);
  const videoOneURLRefs = useRef([]);
  const videoTwoURLRefs = useRef([]);
  const canvasOne1Refs = useRef([]);
  const canvasOne2Refs = useRef([]);
  const canvasTwo1Refs = useRef([]);
  const canvasTwo2Refs = useRef([]);
  const voteRefs = useRef([]);
  const videoOneStateRefs = useRef([]);
  const videoTwoStateRefs = useRef([]);
  const videoPromptRefs = useRef([]);

  const scrollIndex = useRef(0);
  const curPlayVideoIndex = useRef(-1);
  const maxDisplayIndex = useRef(0);
  const observer = useRef(null);

  // Video Metadata (cached from `sample` from API server)
  const [videoMetadata, setVideoMetadata] = useState({});
  const videoMetadataRef = useRef(videoMetadata);

  // Sharing Video variables.
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareVideoURLs, setShareVideoURLs] = useState({
    videoOneURL: "",
    videoTwoURL: "",
  });

  const categoryColors = {
    "aesthetics": "#A96FBA",
    "camera motion": "#784C23",
    "correct physics": "#74870D",
    "prompt matching": "#1C629D",
    "dynamic": "#9C5267",
    "initial": "#000000" // this is just a place holder
  };

  const categoryMessages_all_languages = {
    "ENGLISH": {
      "aesthetics": "Which video has better aesthetics? Vote to reveal model.",
      "camera motion": "Which video has better camera motion? Vote to reveal model.",
      "correct physics": "Which video has more realistic physics? Vote to reveal model.",
      "prompt matching": "Which video follows the prompt better? Vote to reveal model.",
      "dynamic": "Which video is more dynamic? Vote to reveal model.",
      "default": "Vote for the model you prefer."
    },
    // "CHINESE": {
    //   "aesthetics": "哪个视频美学更好？投票以显示模型。",
    //   "camera motion": "哪个视频的相机运动更好？投票以显示模型。",
    //   "correct physics": "哪个视频的物理更真实？投票以显示模型。",
    //   "prompt matching": "哪个视频更好地遵循了提示？投票以显示模型。",
    //   "dynamic": "哪个视频更具动态性？投票以显示模型。",
    //   "default": "投票选择您喜欢的模型。"
    // }

    "CHINESE": {
      "aesthetics": "哪个视频从美学角度更好? 投票以显示模型。",
      "camera motion": "哪个视频的镜头运动更好? 投票以显示模型。",
      "correct physics": "哪个视频的物理更真实? 投票以显示模型。",
      "prompt matching": "哪个视频更好地遵循了提示词? 投票以显示模型。",
      "dynamic": "哪个视频更具动态性? 投票以显示模型。",
      "default": "投票选择您喜欢的模型。"
    }

  };
  const categoryMessages = categoryMessages_all_languages[language];

  // const updateBackgroundColor = (category) => {
  //   const element = document.querySelector('.VideoArenaApp-contents');
  //   const color = categoryColors[category];

  //   if (color) {
  //     element.style.setProperty("background-color", color);
  //   } else {
  //     console.error("Invalid category:", category);
  //   }
  // };

  const categoryRef = useRef("initial"); // TODO(Alex): this is a temporary fix to assign some initial value to categoryref, maybe need to use some default value)
  const categoryMessageRef = useRef("default");
  const prevCategoryRef = useRef("initial"); // TODO (Alex/Brandon): figure out how to solve the lag behind issue

  const updateBackgroundColor = (category) => {
    const transparent = (category == "default" || category == "initial");
    // Get all elements with the class
    const elements = document.getElementsByClassName('VideoArenaApp-contents');
    const color = categoryColors[category];

    if (color && elements.length > 0) {
      // Update all instances of VideoArenaApp-contents
      Array.from(elements).forEach(element => {
        if (!transparent) {
          element.style.setProperty("background-color", color);
        }
        if (transparent) {
          element.style.setProperty("background-color", "transparent");
        }
        //  element.style.removeProperty("background-color");
      });
    } else {
      console.error("Invalid category or no elements found:", category);
    }
  };



  const appBody = (
    <div id="VideoArenaApp-body" className="VideoArenaApp-body" ref={bodyRef}>
      {scrollers}
    </div>
  );

  const PAUSE_PLAY_DELAY_TIME = 150;
  const MAX_LOWER_WINDOW_SIZE = 3;
  const MAX_UPPER_WINDOW_SIZE = 1;




  function getNewToken() {
    setToken("dummy token");
    return "dummy token";
  }

  const VoteTopIcon = (props) => (
    <svg
      width={props.width || "100"}
      height={props.height || "100"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
      <path d="M12 17V11" stroke="#000000" strokeWidth="4" />
      <path d="M7.5 11L12 6L16.5 11H7.5Z" fill="#000000" />
    </svg>
  );

  const VoteBottomIcon = (props) => (
    <svg
      width={props.width || "100"}
      height={props.height || "100"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
      <path d="M12 6V12" stroke="#000000" strokeWidth="4" />
      <path d="M7.5 12L12 18L16.5 12H7.5Z" fill="#000000" />
    </svg>
  );

  const openShareModal = (videoOneURL, videoTwoURL) => {
    console.log("----- openShareModal");
    setShareVideoURLs({ videoOneURL, videoTwoURL });
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    console.log("----- closeShareModal");
    setIsShareModalOpen(false);
  };

  const VoteTopButton = ({ id, desc, onClick }) => {
    const buttonRef = useRef(null);

    return (
      <div>
        <button
          onClick={onClick}
          ref={buttonRef}
          id={id}
          className="VoteButton"
        >
          <VoteTopIcon className="VoteIcon" />
        </button>
        <span className="VoteIconLabel">{desc}</span>
      </div>
    );
  };

  const VoteBalanceButton = ({ id, desc, onClick }) => {
    const buttonRef = useRef(null);
    return (
      <div>
        <button
          onClick={onClick}
          ref={buttonRef}
          id={id}
          className="VoteButton"
        >
          <BalanceIcon />
        </button>
        <span className="VoteIconLabel">{desc}</span>
      </div>
    );
  };

  const VoteDownButton = ({ id, desc, onClick }) => {
    const buttonRef = useRef(null);

    return (
      <div>
        <button
          onClick={onClick}
          ref={buttonRef}
          id={id}
          className="VoteButton"
        >
          <VoteBottomIcon className="VoteIcon" />
        </button>
        <span className="VoteIconLabel">{desc}</span>
      </div>
    );
  };

  const VoteButtons = ({
    videoOneURL = undefined,
    videoTwoURL = undefined,
  }) => {
    const voteTopId = "VoteTop" + videoIndex;
    const voteDownId = "VoteDown" + videoIndex;
    const voteBalanceId = "VoteBalance" + videoIndex;
    const shareId = "Share" + videoIndex;
    const panelId = "VotePanel" + videoIndex;

    const handleShareButtonClick = (
      idSelected,
      videoOneURL = undefined,
      videoTwoURL = undefined
    ) => {
      console.log("----- openShareModal");
      console.log("id selected: ", idSelected);
      console.log("videoOneURL: ", videoOneURL);
      console.log("videoTwoURL: ", videoTwoURL);

      if (videoOneURL !== undefined && videoTwoURL !== undefined) {
        openShareModal(videoOneURL, videoTwoURL);
      } else {
        console.error("Video URLs are not available");
      }
    };

    return (
      <div id={panelId} className="Voting-Panel">
        <div className="VoteButtonContainer">
          <div className="VoteButtonContainer1">
            <div className="VoteLabel">Vote</div>
            <VoteTopButton
              id={voteTopId}
              desc={
                <span>
                  Top
                  <br />
                  <kbd>W</kbd> / <kbd>↑</kbd>
                  <br />
                  <br />
                  ―
                </span>
              }
              onClick={() => voteTop(videoIndex)}
              disabled={false}
            />
            <VoteBalanceButton
              id={voteBalanceId}
              desc={
                <span>
                  Tie
                  <br />
                  <kbd>E</kbd>
                  <br />
                  <br />
                  ―
                </span>
              }
              onClick={() => voteBoth(videoIndex)}
              disabled={false}
            />
            <VoteDownButton
              id={voteDownId}
              desc={
                <span>
                  Down
                  <br />
                  <kbd>S</kbd> / <kbd>↓</kbd>
                  <br />
                </span>
              }
              onClick={() => voteBottom(videoIndex)}
              disabled={false}
            />
          </div>
        </div>
      </div>
    );
  };

  const Videos = ({ id, content }) => {
    return (
      <div
        className="VideoArenaApp-videos"
        id={id}
        ref={(el) => (videosRefs.current[videoIndex] = el)}
      >
        {content}
      </div>
    );
  };

  async function loadVideos() {
    //if ((curViewIndex.current != -1) && ((lastVideoIndex.current - curViewIndex.current) >= MAX_UPPER_WINDOW_SIZE)) {
    if (
      curViewIndex.current != -1 &&
      lastVideoIndex.current - curPlayVideoIndex.current >=
      MAX_UPPER_WINDOW_SIZE
    ) {
      setLoadVideo(false);
      return;
    }

    if (videoLoading.current) {
      setLoadVideo(false);
      return;
    }

    if (loadingDisplay.current) {
      return;
    } else {
      loadingDisplay.current = true;

      const videos = (
        <div className="VideoArenaApp-contents">
          <div className="VideoArenaApp-video-container">
            <div className="VideoArenaApp-video"></div>
            <h3 className="ModelLabel">Loading Model A ...</h3>
          </div>
          <div className="VideoArenaApp-video-divider"></div>
          <div className="VideoArenaApp-video-container">
            <div className="VideoArenaApp-video"></div>
            <h3 className="ModelLabel">Loading Model B ...</h3>
          </div>
          <div className="VideoArenaApp-video-prompt">
            <p>Loading ...</p>
          </div>
          <VoteButtons />
        </div>
      );

      setScrollers([
        ...scrollers,
        <Videos id={videoIndex} content={videos}></Videos>,
      ]);
    }

    if (videoLoading.current) {
      setLoadVideo(false);
      return;
    } else {
      try {
        videoLoading.current = true;
        voteRefs.current[videoIndex] = false;
        loadingIndex.current = videoIndex;
        loadingDisplay.current = false;
        getNewToken();

        const sampleURL = `${baseURL}/api/v1/sample`;
        const params = new URLSearchParams({
          language: language,
        });
        const URL = `${sampleURL}?${params.toString()}`;
        console.log(URL);
        const response = await fetch(URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
        // const response = await fetch(`${baseURL}/api/v1/sample`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        //console.log("----- start video loading (" + videoIndex + ")");
        const data = await response.json();
        const videoOneURL = data.videoA_meta.download_url;
        const videoTwoURL = data.videoB_meta.download_url;
        const prompt = data.prompt;
        console.log("category: ", data.category);
        console.log("prompt: ", prompt);
        prevCategoryRef.current = categoryRef.current;
        categoryRef.current = data.category;
        categoryMessageRef.current = categoryMessages[data.category];
        // updateBackgroundColor(prevCategoryRef.current);
        const videoOneId = "videoOnePlayer" + videoIndex;
        const videoTwoId = "videoTwoPlayer" + videoIndex;

        const modelAId = "ModelA" + videoIndex;
        const modelBId = "ModelB" + videoIndex;

        video1EventListeners.current = false;
        video2EventListeners.current = false;
        lastVideoIndex.current = videoIndex;
        videoOneStateRefs.current[videoIndex] = "undefined";
        videoTwoStateRefs.current[videoIndex] = "undefined";
        videoOneURLRefs.current[videoIndex] = videoOneURL;
        videoTwoURLRefs.current[videoIndex] = videoTwoURL;

        // Updating the state with a function that provides the previous state
        setVideoMetadata((prevMetadata) => {
          const updatedMetadata = {
            ...prevMetadata,
            [videoIndex]: {
              arena_id: data.arena_id,
              videoA_meta: data.videoA_meta,
              videoB_meta: data.videoB_meta,
              prompt: data.prompt,
              time: data.timestamp,
              voted: false,
              category: data.category,
            },
          };
          // Log the updated metadata here
          // console.log('Updated video metadata:', updatedMetadata);
          return updatedMetadata;
        });

        const videoOne = (
          <video
            loop
            muted
            key={videoOneURL}
            id={videoOneId}
            ref={(el) => (videoOneRefs.current[videoIndex] = el)}
            playsInline
            autoPlay
            onClick={() => {
              console.log('Video clicked, voting top');
              voteTop(videoIndex);
            }}
          >
            <source src={videoOneURL} type="video/mp4" preload="metadata" />
            Your browser does not support videos.
          </video>
        );

        const videoTwo = (
          <video
            loop
            muted
            key={videoTwoURL}
            id={videoTwoId}
            ref={(el) => (videoTwoRefs.current[videoIndex] = el)}
            playsInline
            autoPlay
            onClick={() => voteBottom(videoIndex)} // Trigger vote on click
          >
            <source src={videoTwoURL} type="video/mp4" preload="metadata" />
            Your browser does not support videos.
          </video>
        );

        const canvasOne1 = (
          <canvas
            className="VideoArenaApp-video-canvas1"
            ref={(el) => (canvasOne1Refs.current[videoIndex] = el)}
          ></canvas>
        );
        const canvasOne2 = (
          <canvas
            className="VideoArenaApp-video-canvas2"
            ref={(el) => (canvasOne2Refs.current[videoIndex] = el)}
          ></canvas>
        );
        const canvasTwo1 = (
          <canvas
            className="VideoArenaApp-video-canvas1"
            ref={(el) => (canvasTwo1Refs.current[videoIndex] = el)}
          ></canvas>
        );
        const canvasTwo2 = (
          <canvas
            className="VideoArenaApp-video-canvas1"
            ref={(el) => (canvasTwo2Refs.current[videoIndex] = el)}
          ></canvas>
        );



        const videos = (
          <div className="VideoArenaApp-contents">
            <div className="VideoArenaApp-video-container">
              <div className="VideoArenaApp-video-canvas-container">
                {canvasOne1}
                {canvasOne2}
                <div className="VideoArenaApp-video"> {videoOne} </div>
              </div>
              <h3 id={modelAId} className="ModelLabel">
                {categoryMessageRef.current}
              </h3>
            </div>
            <div className="VideoArenaApp-video-divider"></div>
            <div className="VideoArenaApp-video-container">
              <div className="VideoArenaApp-video-canvas-container">
                {canvasTwo1}
                {canvasTwo2}
                <div className="VideoArenaApp-video"> {videoTwo} </div>
              </div>
              <h3 id={modelBId} className="ModelLabel">
                {categoryMessageRef.current}
              </h3>
            </div>
            <div className="VideoArenaApp-video-prompt">
              <VideoPrompt prompt={prompt} index={videoIndex} hide={false} ></VideoPrompt>
              <button
                onClick={() => openShareModal(videoOneURL, videoTwoURL)}
                className="ShareButton"
              >
                <SendIcon className="ShareButton" />
              </button>
            </div>
            <VoteButtons videoOneURL={videoOneURL} videoTwoURL={videoTwoURL} />
          </div>
        );

        setScrollers([
          ...scrollers,
          <Videos id={videoIndex} content={videos}></Videos>,
        ]);

        loadingDisplay.current = true;
      } catch (error) {
        videoLoading.current = false;
        console.error("Failed to load videos:", error);
        setError(true);
      }
    }
  }

  function VideoPrompt({ prompt, index, hide }) {
    const promptRef = useRef(null);
    const promptBoxRef = useRef(null);
    const observer = useRef(null);

    useEffect(() => {
      const promptElement = promptRef.current;
      const promptBox = promptBoxRef.current;

      if (!promptElement || !promptBox) return;

      const showPromptBox = (e) => {
        const { clientX: mouseX, clientY: mouseY } = e;

        // Offsets to position the box up and to the right
        const offsetX = 15; // Horizontal offset from the cursor
        const offsetY = 15; // Vertical offset from the cursor

        // Calculate the position up and to the right of the cursor
        let boxLeft = mouseX + offsetX;
        let boxTop = mouseY - promptBox.offsetHeight - offsetY;

        // Get viewport dimensions
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Adjust if the box goes off the right edge
        if (boxLeft + promptBox.offsetWidth > viewportWidth - 10) {
          boxLeft = viewportWidth - promptBox.offsetWidth - 10;
        }

        // Adjust if the box goes off the top edge
        if (boxTop < 10) {
          // Position it below the cursor if there's no space above
          boxTop = mouseY + offsetY;
          // Ensure it doesn't go off the bottom edge
          if (boxTop + promptBox.offsetHeight > viewportHeight - 10) {
            boxTop = viewportHeight - promptBox.offsetHeight - 10;
          }
        }

        promptBox.style.left = `${boxLeft}px`;
        promptBox.style.top = `${boxTop}px`;
        promptBox.classList.add("show");
      };

      const hidePromptBox = () => {
        promptBox.classList.remove("show");
      };

      // Attach event listeners
      promptElement.addEventListener("mouseover", showPromptBox);
      promptElement.addEventListener("mousemove", showPromptBox);
      promptElement.addEventListener("mouseout", hidePromptBox);

      // Cleanup event listeners on component unmount
      return () => {
        promptElement.removeEventListener("mouseover", showPromptBox);
        promptElement.removeEventListener("mousemove", showPromptBox);
        promptElement.removeEventListener("mouseout", hidePromptBox);
      };
    }, []);

    // Animation effect for scrolling text if it's overflowing
    useEffect(() => {
      const promptElement = promptRef.current;

      if (!promptElement) return;

      const promptHeight = promptElement.scrollHeight;
      const containerHeight = promptElement.parentElement.offsetHeight;

      if (promptHeight > containerHeight) {
        const lineHeight = parseFloat(
          window.getComputedStyle(promptElement).lineHeight
        );
        const numberOfLines = Math.ceil(promptHeight / lineHeight);
        const baseSpeedPerLine = 2.5;
        const scrollSpeed = numberOfLines * baseSpeedPerLine;
        const duration = scrollSpeed;

        promptElement.style.animationDuration = `${duration}s`;
        if (!promptElement.classList.contains("scrollable-text-scroll")) {
          promptElement.classList.add("scrollable-text-scroll");
        }
      } else {
        promptElement.classList.remove("scrollable-text-scroll");
        promptElement.style.animationDuration = "";
      }

      // Observe visibility changes to pause animation when off-screen
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      observer.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            promptElement.style.animationPlayState = "running";
          } else {
            promptElement.style.animationPlayState = "paused";
          }
        });
      }, options);

      observer.current.observe(promptElement);

      return () => {
        if (observer.current) observer.current.disconnect();
      };
    }, [prompt]);


    return (
      <div className="scrollable-prompt" id={`prompt-${index}`} style={{ opacity: hide ? 0 : 1 }}>
        {(
          <>
            <div className="scrollable-text" ref={promptRef}>
              {prompt}
            </div>
            <div ref={promptBoxRef} className="prompt-box">
              {prompt}
            </div>
          </>
        )}
      </div>
    );
  }



  const triggerConfettiAnimation = (index, selected) => {
    const canvasOne1 = canvasOne1Refs.current[index];
    const canvasOne2 = canvasOne2Refs.current[index];
    const canvasTwo1 = canvasTwo1Refs.current[index];
    const canvasTwo2 = canvasTwo2Refs.current[index];
    // heart shape from https://thenounproject.com/icon/heart-1545381/
    // const heart = confetti.shapeFromPath({
    //   path: 'M167 72c19,-38 37,-56 75,-56 42,0 76,33 76,75 0,76 -76,151 -151,227 -76,-76 -151,-151 -151,-227 0,-42 33,-75 75,-75 38,0 57,18 76,56z',
    //   matrix: [0.03333333333333333, 0, 0, 0.03333333333333333, -5.566666666666666, -5.533333333333333]
    // });
    var confettiLeft;
    var confettiRight;
    if (selected === 1) {
      confettiLeft = confetti.create(canvasOne1);
      confettiRight = confetti.create(canvasOne2);
    } else if (selected === 3) {
      confettiLeft = confetti.create(canvasTwo1);
      confettiRight = confetti.create(canvasTwo2);
    }

    if (selected === 1 || selected === 3) {
      confettiLeft({
        particleCount: 75,
        angle: 45,
        spread: 45,
        origin: { x: 0, y: 0.8 },
        // colors: colors
        scalar: 0.35,
        gravity: 0.25,
        startVelocity: 15,
        // shapes: [heart],
        shapes: ["star"],
      });
      confettiRight({
        particleCount: 75,
        angle: 135,
        spread: 45,
        origin: { x: 1, y: 0.8 },
        // colors: colors
        scalar: 0.35,
        gravity: 0.25,
        startVelocity: 15,
        // shapes: [heart],
        shapes: ["star"],
      });
    }

    setTimeout(() => {
      var video1 = videoOneRefs.current[curPlayVideoIndex.current];
      var video2 = videoTwoRefs.current[curPlayVideoIndex.current];
      var state1 = videoOneStateRefs.current[curPlayVideoIndex.current];
      var state2 = videoTwoStateRefs.current[curPlayVideoIndex.current];

      if (index <= lastVideoIndex.current) {
        if (videosRefs.current[index + 1]) {
          videosRefs.current[index + 1].scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 2000);
  };

  const updateVoteButtons = async (index, selected) => {
    const voteTopId = "VoteTop" + index;
    const voteDownId = "VoteDown" + index;
    const voteBalanceId = "VoteBalance" + index;

    if (voteRefs.current[index]) return;
    switch (selected) {
      case 1: // top
        // Code to execute if expression === value1
        document
          .getElementById(voteTopId)
          .style.setProperty("color", "#e75480");
        document
          .getElementById(voteBalanceId)
          .style.setProperty("color", "gray");
        document.getElementById(voteDownId).style.setProperty("color", "gray");
        break;
      case 2: // balance
        document
          .getElementById(voteBalanceId)
          .style.setProperty("color", "orange");
        document.getElementById(voteTopId).style.setProperty("color", "gray");
        document.getElementById(voteDownId).style.setProperty("color", "gray");
        break;
      case 3: // down
        document
          .getElementById(voteDownId)
          .style.setProperty("color", "#90ee90");
        document.getElementById(voteTopId).style.setProperty("color", "gray");
        document
          .getElementById(voteBalanceId)
          .style.setProperty("color", "gray");
        break;
      default:
        // Code to execute if none of the cases match
        console.error("Invalid vote type:", selected);
        return;
    }
    // Disable pressing vote buttons once voted.
    document
      .getElementById(voteTopId)
      .style.setProperty("pointer-events", "none");
    document
      .getElementById(voteBalanceId)
      .style.setProperty("pointer-events", "none");
    document
      .getElementById(voteDownId)
      .style.setProperty("pointer-events", "none");
    voteRefs.current[index] = true;
    maxDisplayIndex.current = index + 1;
    sendVote(index, selected);
    triggerConfettiAnimation(index, selected);
  };

  const sendVote = async (index, voteType) => {
    const properCaps = { 'sora': 'Sora', 'runway': 'Runway', 'svd': 'SVD', 'veo': 'Prerelease', 'pika': 'Pika', 'genmo': 'Genmo', 'kling': 'Kling', 'luma': 'Luma', 'opensora': 'OpenSora', 'minimax': 'Minimax', 'Veo': 'Prerelease' };
    const modelAId = "ModelA" + index;
    const modelBId = "ModelB" + index;
    /* Sends the vote to the API server */
    console.log("Vote to API Server: ", index, voteType);

    const currentMetadata = videoMetadataRef.current[index];
    if (!currentMetadata) {
      console.error("Metadata not available for index:", index);
      return;
    }
    if (currentMetadata.voted) {
      console.error("Already voted for index:", index);
      return;
    }
    let voteId = null;
    switch (voteType) {
      case 1: // top
        voteId = "A";
        break;
      case 2: // balance
        voteId = "TIE";
        break;
      case 3: // down
        voteId = "B";
        break;
      default:
        // Code to execute if none of the cases match
        console.error("Invalid vote type:", voteType);
        return;
    }
    try {
      const voteURL = `${baseURL}/api/v1/vote`;
      const params = new URLSearchParams({
        arena_id: currentMetadata.arena_id,
        vote: voteId,
        user_id: userId.current,
      });
      const URL = `${voteURL}?${params.toString()}`;

      const response = await fetch(URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${data.detail}`);
      }
      setVideoMetadata((prevMetadata) => {
        const updatedMetadata = {
          ...prevMetadata,
          [index]: {
            ...prevMetadata[index],
            videoA_meta: {
              ...prevMetadata[index].videoA_meta,
              modelA: properCaps[data.modelA],
              modelA_version: data.modelA_version,
            },
            videoB_meta: {
              ...prevMetadata[index].videoB_meta,
              modelB: properCaps[data.modelB],
              modelB_version: data.modelB_version,
            },
            vote_type: data.vote,
            voted: true,
            category: prevMetadata[index].category,
            prompt: data.prompt,
          },
        };
        //console.log('Updated video metadata:', updatedMetadata);
        return updatedMetadata;
      });

      document.getElementById(modelAId).textContent = properCaps[data.modelA] + " " + data.modelA_version;
      document.getElementById(modelBId).textContent = properCaps[data.modelB] + " " + data.modelB_version;

      const promptElement = document.getElementById(`prompt-${index}`);
      if (promptElement) {
        promptElement.style.opacity = 1;
      } else {
        console.error("Prompt element not found for index:", index);
      }
      console.log("Vote submitted successfully:", data);
    } catch (error) {
      console.error("Error submitting vote:", error);
    }
  };

  const voteTop = (index) => {
    try {
      updateVoteButtons(index, 1);
    } catch (error) {
      console.error("Error voting:", error);
    }
  };

  const voteBoth = (index) => {
    try {
      updateVoteButtons(index, 2);
    } catch (error) {
      console.error("Error voting:", error);
    }
  };

  const voteBottom = (index) => {
    try {
      updateVoteButtons(index, 3);
    } catch (error) {
      console.error("Error voting:", error);
    }
  };

  const onKeyDown = (event) => {
    //console.log('onKeyDown ----- ', event.key, scrollIndex.current);
    if (!props.generate) {
      if (event.key === "ArrowUp" || event.key == "w" || event.key == "W") {
        event.preventDefault();
        console.log("---------------top", scrollIndex.current);
        voteTop(scrollIndex.current);
      } else if (
        event.key === "ArrowDown" ||
        event.key == "s" ||
        event.key == "S"
      ) {
        event.preventDefault();
        voteBottom(scrollIndex.current);
      } else if (event.key === "e" || event.key === "E") {
        event.preventDefault();
        voteBoth(scrollIndex.current);
      }
    }
  };

  const unloadVideo = (index) => {
    if (
      videoOneStateRefs.current[index] === "undefined" ||
      videoTwoStateRefs.current[index] === "undefined"
    ) {
      return;
    }

    const video1 = videoOneRefs.current[index];
    const video2 = videoTwoRefs.current[index];

    if (video1 && video2) {
      const source1Element = video1.querySelector("source");
      const source2Element = video2.querySelector("source");

      console.log("----- unloadVideo index", index);

      if (source1Element) {
        video1.pause();
        source1Element.src = "";
        video1.load(); // Reload the video to apply the new source
        videoOneStateRefs.current[index] = "undefined";
      }
      if (source2Element) {
        video2.pause();
        source2Element.src = "";
        video2.load(); // Reload the video to apply the new source
        videoTwoStateRefs.current[index] = "undefined";
      }
    }
  };

  const reloadVideo = (index) => {
    if (
      videoOneStateRefs.current[index] != "undefined" ||
      videoTwoStateRefs.current[index] != "undefined"
    ) {
      return;
    }

    const video1 = videoOneRefs.current[index];
    const video2 = videoTwoRefs.current[index];
    const source1Element = video1.querySelector("source");
    const source2Element = video2.querySelector("source");
    const video1URL = videoOneURLRefs.current[index];
    const video2URL = videoTwoURLRefs.current[index];

    console.log("----- reloadVideo index", index);

    if (source1Element) {
      source1Element.src = video1URL;
      video1.load(); // Reload the video to apply the new source
    }

    if (source2Element) {
      source2Element.src = video2URL;
      video2.load(); // Reload the video to apply the new source
    }
  };

  const balanceVideos = () => {
    const preBottomVideoIndex = bottomVideoIndex.current;
    const preTopVideoIndex = topVideoIndex.current;
    const playIndex = curPlayVideoIndex.current;

    if (playIndex <= MAX_LOWER_WINDOW_SIZE) {
      bottomVideoIndex.current = 0; // bottom should be larger than 0
    } else {
      bottomVideoIndex.current = playIndex - MAX_LOWER_WINDOW_SIZE;
    }

    topVideoIndex.current = playIndex + MAX_UPPER_WINDOW_SIZE;
    if (topVideoIndex.current > lastVideoIndex.current) {
      topVideoIndex.current = lastVideoIndex.current;
    }

    for (let i = preBottomVideoIndex; i < bottomVideoIndex.current; i++) {
      unloadVideo(i);
    }

    for (let i = preTopVideoIndex; i > topVideoIndex.current; i--) {
      unloadVideo(i);
    }

    for (let i = bottomVideoIndex.current; i <= topVideoIndex.current; i++) {
      reloadVideo(i);
    }
  };

  const playVideos = (timeout) => {
    if (curViewIndex.current > maxDisplayIndex.current) {
      console.log(
        "no play ----------",
        curViewIndex.current,
        maxDisplayIndex.current
      );
      setTimeout(function () {
        console.log("timeout --------------", curPlayVideoIndex.current);
        videosRefs.current[curPlayVideoIndex.current].scrollIntoView({
          behavior: "auto",
        });
      }, 500);
      return;
    }

    if (playId.current !== undefined) {
      clearTimeout(playId.current);
      playId.current = undefined;
      isPausePlayTimersRunning.current = false;
    }

    if (pauseId.current !== undefined) {
      clearTimeout(pauseId.current);
      pauseId.current = undefined;
      isPausePlayTimersRunning.current = false;
    }

    if (
      videoOneRefs.current[curViewIndex.current] === "play" ||
      videoOneRefs.current[curViewIndex.current] === "playing" ||
      videoTwoRefs.current[curViewIndex.current] === "play" ||
      videoTwoRefs.current[curViewIndex.current] === "playing" ||
      curPlayVideoIndex.current === -1
    ) {
      if (lastVideoIndex.current - curViewIndex < MAX_UPPER_WINDOW_SIZE)
        loadVideos();
      return;
    }

    isPausePlayTimersRunning.current = true;
    // pause first, then start timer to play again
    pauseId.current = setTimeout(function () {
      pauseId.current = undefined;
      var video1 = videoOneRefs.current[curPlayVideoIndex.current];
      var video2 = videoTwoRefs.current[curPlayVideoIndex.current];
      var state1 = videoOneStateRefs.current[curPlayVideoIndex.current];
      var state2 = videoTwoStateRefs.current[curPlayVideoIndex.current];

      if (state1 === "play" || state2 === "play") {
        // cannot pause when state is in play
        setLoadVideo(true);
        return;
      }

      if (video1 && video2) {
        if (state1 === "playing") {
          video1.pause();
          video1.currentTime = 0;
        }

        if (state2 === "playing") {
          video2.pause();
          video2.currentTime = 0;
        }
      }
      console.log("----- pause", curPlayVideoIndex.current, state1, state2);

      playId.current = setTimeout(function () {
        playId.current = undefined;
        // we cannot use target id
        // we need to use the current id
        const playIndex =
          curViewIndex.current > maxDisplayIndex.current
            ? maxDisplayIndex.current
            : curViewIndex.current;

        var video1 = videoOneRefs.current[playIndex];
        var video2 = videoTwoRefs.current[playIndex];
        var state1 = videoOneStateRefs.current[playIndex];
        var state2 = videoTwoStateRefs.current[playIndex];

        if (video1 && video2) {
          console.log("----- play", playIndex, state1, state2);

          if (state1 === "loadedmetadata" || state1 === "pause") {
            video1.play();
          }
          if (state2 === "loadedmetadata" || state2 === "pause") {
            video2.play();
          }

          curPlayVideoIndex.current = playIndex;
          if (curPlayVideoIndex.current < curViewIndex.current) {
            console.log("scrolling into view", curPlayVideoIndex.current);
            videosRefs.current[curPlayVideoIndex.current].scrollIntoView({
              behavior: "smooth",
            });
          }
          updateBackgroundColor(videoMetadataRef.current[playIndex].category);
        }



        isPausePlayTimersRunning.current = false;
        balanceVideos();
        setLoadVideo(true);
        console.log(
          "----- [",
          bottomVideoIndex.current,
          playIndex,
          topVideoIndex.current,
          "]",
          lastVideoIndex.current
        );
      }, timeout);
    }, timeout);
  };

  const activateButtons = () => {
    if (
      videoOneStateRefs.current[videoIndex] != "undefined" &&
      videoTwoStateRefs.current[videoIndex] != "undefined"
    ) {
      const panelId = "VotePanel" + videoIndex;

      var video1 = videoOneRefs.current[videoIndex];
      var video2 = videoTwoRefs.current[videoIndex];

      if (!video1 || !video2) return;
      if (curPlayVideoIndex.current === -1 && videoIndex === 0) {
        // start the first video set playing
        //console.log('first start playing videos(' + video1.id + ")");
        curPlayVideoIndex.current = 0;
        video1.play();
        video2.play();
        updateBackgroundColor(videoMetadataRef.current[videoIndex].category);
      }
      // enable vote buttons
      if (
        document.getElementById(panelId).style.getPropertyValue("visibility") !=
        "visible"
      ) {
        console.log("----- activate", panelId);
        document
          .getElementById(panelId)
          .style.setProperty("visibility", "visible");
      }
      if (videoIndex === lastVideoIndex.current) {
        // this is the video currently
        setVideoIndex(videoIndex + 1);
        if (
          topVideoIndex.current <
          curPlayVideoIndex.current + MAX_UPPER_WINDOW_SIZE
        ) {
          topVideoIndex.current = videoIndex;
        }
        console.log(
          "----- k[",
          bottomVideoIndex.current,
          curPlayVideoIndex.current,
          topVideoIndex.current,
          "]",
          lastVideoIndex.current
        );
        videosRefs.current[curPlayVideoIndex.current].scrollIntoView({
          behavior: "smooth",
        });
        if (videoIndex !== 0 && curPlayVideoIndex.current === videoIndex) {
          playVideos(PAUSE_PLAY_DELAY_TIME);
        }
      } else {
        // check if current view is playing
        if (
          videoOneStateRefs[curViewIndex.current] !== "play" &&
          videoOneStateRefs[curViewIndex.current] !== "playing"
        ) {
          playVideos(PAUSE_PLAY_DELAY_TIME);
        }
      }
      loadVideos();
    }
  };

  const onScroll = (event) => {
    var up_or_down = event.deltaY > 0 ? 1 : -1; // up: -1, down: +1
    if (up_or_down === 1) {
      if (
        curViewIndex.current >= maxDisplayIndex ||
        !voteRefs.current[scrollIndex.current]
      ) {
        event.preventDefault();
      }
    }
  };

  useEffect(() => {
    console.log("----- enter VideoArenaAppBody userId =", userId.current);
    if (bodyRef.current) {
      bodyRef.current.removeEventListener("wheel", onScroll);
      bodyRef.current.addEventListener("wheel", onScroll);
    }

    window.addEventListener("scroll", onScroll);
    return () => {
      if (bodyRef.current) {
        bodyRef.current.removeEventListener("wheel", onScroll);
      }
    };
  }, []);

  useEffect(() => {
    userId.current = props.userId;
    console.log("----- update VideoArenaAppBody userId =", userId.current);
  }, [props.userId]);

  // Ensure that videoMetadataRef is updated when the videoMetadata state changes.
  useEffect(() => {
    videoMetadataRef.current = videoMetadata;
  }, [videoMetadata]);

  useEffect(() => {
    videoLoading.current = false;
    loadingDisplay.current = false;
    loadVideos();
  }, [videoIndex]);

  useEffect(() => {
    if (loadVideo) loadVideos();
  }, [loadVideo]);

  useEffect(() => {
    if (token === undefined) {
      // force loading the first video set
      loadVideos();
      return;
    }

    var video1 = videoOneRefs.current[videoIndex];
    var video2 = videoTwoRefs.current[videoIndex];

    if (!video1 && !video2) {
      return;
    }

    // IntersectionObserver
    const options = {
      root: bodyRef.current,
      rootMargin: "0px",
      threshold: 0.5,
    };


    if (!observer.current) {
      observer.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            curViewIndex.current = +entry.target.id; // use '+' to force the target.id to a number
            scrollIndex.current = curViewIndex.current;
            playVideos(PAUSE_PLAY_DELAY_TIME);
          }
        });
      }, options);
    }

    const elements = document.querySelectorAll(".VideoArenaApp-videos");
    elements.forEach((element) => observer.current.observe(element));

    const handleVideoOneLoaded = () => {
      //console.log("ssssss----------------- loadedmetadata", videoIndex);
      videoOneStateRefs.current[videoIndex] = "loadedmetadata";
      activateButtons();
    };

    const handleVideoTwoLoaded = () => {
      //console.log("jjjjj----------------- loadedmetadata", videoIndex);
      videoTwoStateRefs.current[videoIndex] = "loadedmetadata";
      activateButtons();
    };

    const videoOnePlay = () => {
      //console.log("ssssss----------------- play", videoIndex);
      videoOneStateRefs.current[videoIndex] = "play";
    };

    const videoTwoPlay = () => {
      //console.log("jjjjj----------------- play", videoIndex);
      videoTwoStateRefs.current[videoIndex] = "play";
    };

    const videoOnePlaying = () => {
      //console.log("ssssss----------------- playing", videoIndex);
      videoOneStateRefs.current[videoIndex] = "playing";
      if (videoIndex !== curPlayVideoIndex.current) {
        videoOneRefs.current[videoIndex].pause();
      }
    };

    const videoTwoPlaying = () => {
      //console.log("jjjjj----------------- playing", videoIndex);
      videoTwoStateRefs.current[videoIndex] = "playing";
      if (videoIndex !== curPlayVideoIndex.current) {
        videoTwoRefs.current[videoIndex].pause();
      }
    };

    const videoOnePause = () => {
      //console.log("ssssss----------------- pause", videoIndex);
      videoOneStateRefs.current[videoIndex] = "pause";
    };

    const videoTwoPause = () => {
      //console.log("jjjjj----------------- pause", videoIndex);
      videoTwoStateRefs.current[videoIndex] = "pause";
    };

    const videoOneFinished = () => {
      //console.log("ssssss----------------- finished", videoIndex);
      videoOneStateRefs.current[videoIndex] = "ended";
    };

    const videoTwoFinished = () => {
      //console.log("jjjjj----------------- finished", videoIndex);
      videoTwoStateRefs.current[videoIndex] = "ended";
    };

    if (video1 && !video1EventListeners.current) {
      video1.addEventListener("loadedmetadata", handleVideoOneLoaded);
      video1.addEventListener("play", videoOnePlay);
      video1.addEventListener("playing", videoOnePlaying);
      video1.addEventListener("pause", videoOnePause);
      video1.addEventListener("ended", videoOneFinished);
      video1EventListeners.current = true;
    }

    if (video2 && !video2EventListeners.current) {
      video2.addEventListener("loadedmetadata", handleVideoTwoLoaded);
      video2.addEventListener("play", videoTwoPlay);
      video2.addEventListener("playing", videoTwoPlaying);
      video2.addEventListener("pause", videoTwoPause);
      video2.addEventListener("ended", videoTwoFinished);
      video2EventListeners.current = true;
    }
  }, [scrollers]);

  useEffect(() => {
    if (!props.generate && !isShareModalOpen) {
      document.addEventListener("keydown", onKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [props.generate, isShareModalOpen]);

  return (
    <div id="bodyAndModal">
      <div id="VideoArenaAppBody" className="VideoArenaAppBody">
        {error ? (
          <div className="error-message">
            Failed to load videos. Please try again later.
          </div>
        ) : (
          appBody
        )}
      </div>
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={closeShareModal}
        videoOneURL={shareVideoURLs.videoOneURL}
        videoTwoURL={shareVideoURLs.videoTwoURL}
      />
    </div>
  );
}

export default VideoArenaAppBody;
